import ModelsContext from '@/lib/contexts/ModelsContext';
import { useContext } from 'react';
import useDefaultModel from './useDefaultModel';
import PortfolioItemContext from '../../PortfolioItemContext';
import type ModelType from '@/lib/constants/challengeModel/ModelType.enum';
import { type Model } from '@/lib/types';

const usePortfolioItemModel = (modelType: ModelType): Model | null => {
  const models = useContext(ModelsContext);
  const defaultModel = useDefaultModel(modelType);

  const { portfolioItem } = useContext(PortfolioItemContext);

  if (Object.keys(models[modelType]).length === 0) {
    return null;
  }

  if (portfolioItem.modelId === null) {
    return defaultModel;
  }

  const portfolioItemModel = models[modelType][portfolioItem.modelId];

  if (typeof portfolioItemModel === 'undefined') {
    return defaultModel;
  }

  return portfolioItemModel;
};

export default usePortfolioItemModel;
